/**
 * Programme Responses component created by karora on 26/05/17.
 */
import {Component} from "@angular/core";

@Component({
    selector: 'programme-responses',
    template: `<programme-detail></programme-detail><responses></responses>`,
    styleUrls: [],
    providers: [],
    standalone: false
})


export class ProgrammeResponsesComponent {

  constructor(
  ) { }

}
